import { RouteObject, Navigate } from 'react-router-dom';
import { EditorRoutes } from './modules/editor/routes';
import { ThemesRoutes } from './modules/themes/routes';
import { CmsRoutes } from './modules/cms/routes';
import { ErpBlocksRoutes } from './modules/erp-blocks/routes';
import { FormsRoutes } from './modules/forms/routes';
import { StorefrontRoutes } from './modules/storefront/routes';
import { DomainsRoutes } from './modules/domains/routes';
import { AnalyticsRoutes } from './modules/analytics/routes';

// webbuilderRoutes declares all 8 suite sub-routes matching WEBBUILDER_MODULES (R-UI-5).
export const webbuilderRoutes: RouteObject[] = [
  { index: true, element: <Navigate to="/webbuilder/pages" replace /> },
  EditorRoutes,
  ThemesRoutes,
  CmsRoutes,
  ErpBlocksRoutes,
  FormsRoutes,
  StorefrontRoutes,
  DomainsRoutes,
  AnalyticsRoutes,
];

export default webbuilderRoutes;
